import doctorImg from '../assets/images/docter-profile.png';

export const testimonials = [
  {
    id: 1,
    avatar: doctorImg,
    quote:
      '"Traveling from Kenya for my heart surgery felt overwhelming at first, but the hospital team guided me through every step. The doctors explained everything clearly, and after my procedure, I felt safe and well cared for. I\'m truly grateful for the warmth and professionalism I experienced".',
    name: 'Dr. Malik',
    role: 'Senior Cardiologist, Apollo Hospitals',
  },
  {
    id: 2,
    avatar: doctorImg,
    quote:
      '"Traveling from Kenya for my heart surgery felt overwhelming at first, but the hospital team guided me through every step. The doctors explained everything clearly, and after my procedure, I felt safe and well cared for. I\'m truly grateful for the warmth and professionalism I experienced".',
    name: 'Dr. Malik',
    role: 'Senior Cardiologist, Apollo Hospitals',
  },
  {
    id: 3,
    avatar: doctorImg,
    quote:
      '"Traveling from Kenya for my heart surgery felt overwhelming at first, but the hospital team guided me through every step. The doctors explained everything clearly, and after my procedure, I felt safe and well cared for. I\'m truly grateful for the warmth and professionalism I experienced".',
    name: 'Dr. Malik',
    role: 'Senior Cardiologist, Apollo Hospitals',
  },
  {
    id: 4,
    avatar: doctorImg,
    quote:
      '"Traveling from Kenya for my heart surgery felt overwhelming at first, but the hospital team guided me through every step. The doctors explained everything clearly, and after my procedure, I felt safe and well cared for. I\'m truly grateful for the warmth and professionalism I experienced".',
    name: 'Dr. Malik',
    role: 'Senior Cardiologist, Apollo Hospitals',
  },
  {
    id: 5,
    avatar: doctorImg,
    quote:
      '"Traveling from Kenya for my heart surgery felt overwhelming at first, but the hospital team guided me through every step. The doctors explained everything clearly, and after my procedure, I felt safe and well cared for. I\'m truly grateful for the warmth and professionalism I experienced".',
    name: 'Dr. Malik',
    role: 'Senior Cardiologist, Apollo Hospitals',
  },
];
